import {PageHeader} from "@ant-design/pro-layout";
import {getImageLink, navigateBackHandler} from "../../helpers/mainHelpers";
import "./style.less"
import {Empty, Spin} from "antd";
import Gallery from "../../components/galerry/Gallery";
import AddActionButton from "../../components/action-buttons/addAction-button/AddActionButton";
import {useStaffController} from "../../controllers/staff-controller";
import {useOfficeController} from "../../controllers/office-controller";
import {useParams} from "react-router-dom";
import React, {useEffect, useMemo} from "react";
import * as BUCKETS from "../../enums/buckets"
import StaffList from "../../components/staff-list/StaffList";
import {useAuth} from "../../context/authContext";
import TextReader from "../../components/text-reader/TextReader";
import {Query} from "appwrite";
import ScrollToTopButton from "../../components/main-buttons/scroll-button/ScrollToTopButton";
import {CameraOutlined, MedicineBoxOutlined, TeamOutlined} from "@ant-design/icons";

const OfficePage = () => {
  const staffController = useStaffController()
  const officesController = useOfficeController()
  const {getOfficeItem, selectedOffice, isLoading} = officesController
  const {officeId} = useParams()
  const {canManageContent} = useAuth()

  useEffect(() => {
    if (officeId) getOfficeItem(officeId)
  }, [officeId])

  useEffect(() => {
    if (selectedOffice) {
      staffController.fetchStaffList([Query.equal("offices", officeId || "")])
    }
  }, [selectedOffice, staffController.lastUpdate])

  const galleryImages = useMemo(() => {
    return selectedOffice?.images
      ?.filter((imageId) => imageId !== selectedOffice.mainImage)
      .map((imageId) => getImageLink({imageId, bucketId: BUCKETS.MAIN})) || []
  }, [selectedOffice])

  const openAddStaffModal = () => {
    staffController.toggleCreateModal({selectedStaff: undefined, isModalOpen: true})
  }

  return <>
    <div className="page_title department-page__navigation">
      <PageHeader
        title={<div className="page-header_title"><div className="page_name">{selectedOffice?.name}</div></div>}
        onBack={navigateBackHandler}
      />
    </div>

    <div className="page_content department-page__content">
      <Spin spinning={isLoading}>
        {selectedOffice ? <main className="department-page office-page">
          <section className="department-hero" aria-labelledby="office-title">
            <div className="department-hero__media">
              {selectedOffice.mainImage
                ? <img className="department-hero__image"
                       src={getImageLink({imageId: selectedOffice.mainImage, bucketId: BUCKETS.MAIN})}
                       alt={selectedOffice.name}/>
                : <div className="department-hero__placeholder" aria-hidden="true"><MedicineBoxOutlined/></div>}
            </div>
            <div className="department-hero__content">
              <div className="department-hero__eyebrow"><MedicineBoxOutlined/> Медичний підрозділ</div>
              <h1 className="department-hero__title" id="office-title">{selectedOffice.name}</h1>
              <div className="department-hero__about"><TextReader value={selectedOffice.about}/></div>
            </div>
          </section>

          <section className="department-section department-page__staff" aria-labelledby="office-staff-title">
            <header className="department-section__header">
              <div>
                <div className="department-section__eyebrow"><TeamOutlined/> Команда</div>
                <h2 className="department-section__title" id="office-staff-title">Працівники підрозділу</h2>
              </div>
              {canManageContent && <AddActionButton size="small" onClick={openAddStaffModal}/>}
            </header>
            <StaffList staffController={staffController}/>
          </section>

          {galleryImages.length > 0 && <section className="department-section department-page__gallery" aria-labelledby="office-gallery-title">
            <header className="department-section__header">
              <div>
                <div className="department-section__eyebrow"><CameraOutlined/> Простір підрозділу</div>
                <h2 className="department-section__title" id="office-gallery-title">Фотогалерея</h2>
              </div>
            </header>
            <Gallery images={galleryImages}/>
          </section>}
        </main> : !isLoading && <div className="department-page__empty"><Empty description="Підрозділ не знайдено"/></div>}
      </Spin>
      <ScrollToTopButton elementSelector={".page_content"}/>
    </div>
  </>
}

export default OfficePage
